import React from 'react';

import { BkLogoRevamp } from 'components/logo/bk-logo-revamp';
import { RpFrLogoRevamp, RpLogoRevamp } from 'components/logo/rp-logo-revamp';
import { useAuthContext } from 'state/auth';
import useIntl from 'state/intl/hook';
import { LANGUAGES } from 'state/intl/types';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const Logo: React.FC = props => {
  const { isAuthenticated } = useAuthContext();
  const { language } = useIntl();
  const enableHeaderRevamp = useFlag(LaunchDarklyFlag.ENABLE_REVERT_HEADER_REVAMP);

  if (!enableHeaderRevamp) {
    return <BkLogoRevamp {...props} />;
  }

  const RpLogo = language === LANGUAGES.en ? RpLogoRevamp : RpFrLogoRevamp;

  return isAuthenticated ? <RpLogo {...props} /> : <BkLogoRevamp {...props} />;
};
